import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchDropdown } from '../../../actions/actionCreators';
import { renderSearchDropDown } from '../../common/form/FieldHelper';

class IntegrationDropdown extends Component {
  render() {
    const {
      form,
      isFix,
      listOptions,
      name,
      onPostChange,
      searchFn,
      type_id,
      ...otherProps
    } = this.props;

    return (
      <div className="field">
        <Field
          {...otherProps}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="integration"
          type="integration"
          valueField="id"
          listOptions={listOptions}
          component={renderSearchDropDown}
          onPostChange={onPostChange}
          isFix={isFix}
          searchParams={{ type_id }}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch
  );
}

IntegrationDropdown = connect(
  null,
  mapDispatchToProps
)(IntegrationDropdown);

export default IntegrationDropdown;
